/**
 * Main landing page for the application.
 * This component serves as the entry point for users visiting the root URL.
 * 
 * Changes made during cleanup:
 * - Removed redundant Home.tsx component that duplicated this functionality
 * - Removed unused pages: Pricing.tsx (pricing is now a section on this page),
 *   ViewPosit.tsx, PositTask.tsx, CompTest.tsx, and AdminTools.tsx
 * - Removed gradient background and replaced with solid background
 * - Added referral tracking for affiliate links
 */
import { useEffect, useState } from "react";
import HeroSection from "@/components/landing/HeroSection";
import FeatureShowcase from "@/components/landing/FeatureShowcase";
import PricingSection from "@/components/landing/PricingSection";
import FAQSection from "@/components/landing/FAQSection";
import Footer from "@/components/landing/Footer";
import { useReferralTracking } from "@/hooks/useReferralTracking";
import { capture } from "@/lib/posthog";

const Index = () => {
  // Initialize referral tracking for affiliate links
  useReferralTracking();
  
  // Add debugging logs to track component lifecycle
  useEffect(() => {
    return () => {
    };
  }, []);

  // Example: capture CTA clicks (ids must match site elements)
  const onCtaClick = (id: string) => {
    capture('marketing_cta_click', { cta_id: id, location: 'index' });
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-[2000px] mx-auto">
        <div className="space-y-2">
          <HeroSection onPrimaryClick={() => onCtaClick('hero_primary')} />
          <FeatureShowcase />
          <PricingSection />
          <FAQSection />
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Index;
